import * as React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Diamonds} from '../Components/Diamonds';
import Radium from 'radium';
import * as Tgcc from '../tgccGlobal';

const mobileBreakpoint = '@media (max-width: 768px)';


const ulStyle:React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    width:'160px',
    color:'white',
    cursor:'pointer',
    paddingLeft:'0px',
    position:'relative',
    [mobileBreakpoint]: {
        display: 'flex', // Stack list items vertically on small screens
        width: '100%', // Full width
        marginBottom: '15px', // Add some space between each ul
        position: 'static',
        textAlign: 'center', // Center-align text
    },

}

const socialMediaAditional:React.CSSProperties = {
    filter: 'invert(100%)',
}
var socialMediaUl = Object.assign({},ulStyle, socialMediaAditional,{});
var ulStyle1 = Object.assign({},ulStyle,{});
const licenseUL: React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    width:'160px',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
    position:'relative',
}

const socialLink: React.CSSProperties = {
    textDecoration:'none'
}

const bottomListStyle: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor:'rgb(24, 17, 71)',
    [mobileBreakpoint]: {
        padding: '20px', // Add padding on mobile for better spacing
        display: 'block',
    },
}

const footerStyles: React.CSSProperties = {
    textAlign:'center',
    lineHeight:'4.2em',
    backgroundColor:'rgb(24, 17, 71)',
    width:'100%',
    height:'61px',
    fontFamily:'Lulo',
    color:'white',
    [mobileBreakpoint]: {
        lineHeight: 'normal', // Adjust line height on mobile
        height: 'auto', // Height auto for flexibility
        padding: '20px 0', // Add some vertical padding
    },
}
const containerDiv: React.CSSProperties = {
    width:'100%',
}

const licenseStyle: React.CSSProperties = {
    width:'313px',
    height:'150px'
}
const groupImg: React.CSSProperties = {
    width:'313px',
    filter: 'invert(100%)',
    cursor: 'default',

}
const groupUL: React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
}
const footerLi: React.CSSProperties = {
    marginBottom:'15px'
}

const liTurnAround: React.CSSProperties = {
    position:'relative',
    top:'19px'
}

const socialMediaIcons: React.CSSProperties = {
    width:'25px',
    [mobileBreakpoint]: {
        width: '40px', // Increase icon size for better touch targets
    },
}
const socialMediaLi: React.CSSProperties = {
    display:'inline-block',
    marginRight:'5px',
    [mobileBreakpoint]: {
        margin: '10px auto', // Add margin for spacing and centering
        display: 'block', // Ensure list items stack vertically
    },
}

import { StyleRoot } from 'radium';

class _TBankerFooter extends React.Component <Tgcc.BaseProps,any > {

    openContact = () =>{browserHistory.push(Tgcc.Routes.Contact)};
    openAbout = () =>{browserHistory.push(Tgcc.Routes.About)};
    openShipping = () => {browserHistory.push(Tgcc.Routes.MajorAccountShipping)};
    openFAQ = () => {browserHistory.push(Tgcc.Routes.MajorAccountsFAQ)};


    getBottomSection(){
        return (
            <StyleRoot>
                <div style={bottomListStyle} className="corpFooterCont">
                <ul style={groupUL} className="corpFooterLic">
                        <li><img style={groupImg} src={Tgcc.ResolveUrl('~/images/Footer-01-01.png')} /></li>
                    </ul>

                    <ul style={socialMediaUl} className="socialMediaUl">
                        <li style={socialMediaLi}><a style={socialLink} href="https://www.facebook.com/thegraphiccow"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Facebook.png')} /></a></li>
                        <li style={socialMediaLi}><a href="https://www.instagram.com/thegraphiccow/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Instagram.png')} /></a></li>
                        <li style={socialMediaLi}><a href="https://www.pinterest.com/grafcowcompany/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Pinterest.png')} /></a></li>
                    </ul>
                    <ul style={ulStyle} className="corpFooterUl">
                        <li style={footerLi}><i><div onClick={this.openAbout}>About Us</div></i></li>
                        <li style={footerLi}><i><div onClick={this.openContact}>Contact</div></i></li>
                        <li><div onClick={this.openFAQ}><i>FAQS</i></div></li>
                        <li style={liTurnAround}><div onClick={this.openShipping}><i>Turn Around &#38; Returns</i></div></li>
                    </ul>
                    
                </div>
            </StyleRoot>

        )
    }
    getFooter(){
        return (
                <div style={footerStyles}>2024 BY THE GRAPHIC COW COMPANY</div>
        )
    }

    render() {
            return (
            <div style={containerDiv} className="corpBottomDiv">
                {this.getBottomSection()}
                {this.getFooter()}
            </div>
        ) 
    }
}


const mapStateToProps = (state: Tgcc.GlobalState, ownProps: Tgcc.BaseProps) => {
    return { state: state};
};
export var TBankerFooter = connect(mapStateToProps)(Radium(_TBankerFooter));

